module.exports = __webpack_public_path__ + "apple-icon-180x180.dd2a24f7.png";